<app-nav-header *ngIf="!service.loading" ></app-nav-header>
<router-outlet></router-outlet>


<app-footer *ngIf="!service.loading"></app-footer>

<app-spinner *ngIf="service.loading"></app-spinner>

<!-- Footer body html -->
